var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.hasCode && _vm.goodCode)?_c('div',[(_vm.isMobile)?_c('mobile-version'):_c('home-desktop')],1):_c('div',{staticClass:"default-wrapper"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }